import styled from '@emotion/styled';
import { createPortal } from 'react-dom';
import React, { useEffect, useMemo } from 'react';

import { assetUrl } from '~/helpers';
import ErrorLayout from './ErrorLayout';
import { ErrorLayoutProps } from './ErrorLayout';

const Image = styled.img`
  margin-top: 110px;
  margin-bottom: 50px;
`;

export type ErrorXXXProps = Pick<ErrorLayoutProps, 'httpCode'> &
  Partial<Pick<ErrorLayoutProps, 'message' | 'title' | 'fullPage'>>;

export default function ErrorXXX({
  httpCode,
  message = 'Sorry there has been an error, please try again in a few minutes.',
  title = 'Oops! Something went wrong…',
  fullPage = true,
}: ErrorXXXProps) {
  return (
    <ErrorLayout
      title={title}
      message={message}
      httpCode={httpCode}
      fullPage={fullPage}
    >
      <Image
        className='error-image'
        src={assetUrl('assets/images/joro/500.png')}
        width={170}
        height={150}
      />
    </ErrorLayout>
  );
}

export function ErrorXXXPortal(props: ErrorXXXProps) {
  useEffect(() => {
    document.body.classList.add('error-page');

    return () => document.body.classList.remove('error-page');
  }, []);

  const target = useMemo(() => {
    const target = document.createElement('div');
    target.innerHTML = '';

    return target;
  }, []);

  useEffect(() => {
    document.body.appendChild(target);

    return () => {
      target && document.body.removeChild(target);
    };
  }, []);

  return createPortal(<ErrorXXX {...props} />, target);
}
